//import React from 'react';
//import { MapPinHouse, Map } from "lucide-react";
//import { FaMap } from "react-icons/fa6";
//import { FaArrowsToEye, FaStreetView} from "react-icons/fa6";
//import { PiMapPinAreaFill } from "react-icons/pi";
//import { TbMapUp, TbMapSearch } from "react-icons/tb";
//import { TbMapSearch } from "react-icons/tb";
//import { RiEye2Line } from "react-icons/ri";
//import { TiEyeOutline } from "react-icons/ti";
//import { ImEye } from "react-icons/im";
//import { FaEye } from "react-icons/fa";
//import { HiEye } from "react-icons/hi";
import { PiEyeFill } from "react-icons/pi";
//import { ScanEye } from "lucide-react";

//import "./ImageGrid.css";
import "./ImageCell.css";

const ImageCellViewButton = ({ onClick, bgColor }) => {
  return (
    <>
      <button
        className="image-action-btn-view"
        onClick={onClick}
        title="voir en grand"
        style={{ backgroundColor: bgColor }}
      >
        <PiEyeFill size={20} strokeWidth={0} />
      </button>
    </>
  );
};

export default ImageCellViewButton;
/*

<MapPinHouse />
<LocateFixed />
<Target />
<Eye />
<MapPinned />
<ScanEye />
*/
